import { Alert, Form, Input } from 'antd';
import type { Chain } from '../features/catalog/api';
import { KAS_CODE_MAX, kasChainsInScope } from './kasPromoCode';

/**
 * Bộ ô nhập mã khuyến mãi KAS, một ô cho mỗi chuỗi **đang trong phạm vi** (`S4-Web-05`).
 *
 * Giá trị của field là `Record<chainId, code>` chứ không phải mảng: form chỉ cần gán và đọc theo
 * chuỗi, còn việc dựng mảng gửi lên là của `toKasPayload` — nơi duy nhất biết phạm vi hiện tại.
 */
export function KasPromoCodeFields({
  chains,
  /** `null`/`undefined` = toàn hệ thống, nên một ô mỗi chuỗi. Có giá trị = một ô duy nhất. */
  chainId,
  value,
  onChange,
}: {
  chains: Chain[];
  chainId?: string | null;
  value?: Record<string, string>;
  onChange?: (next: Record<string, string>) => void;
}) {
  const inScope = kasChainsInScope(chains, chainId);
  const current = value ?? {};

  if (inScope.length === 0) {
    return (
      <Alert
        type="info"
        showIcon
        message="Chưa có chuỗi nào để khai mã"
        description="Tạo chuỗi ở mục Chuỗi và chi nhánh trước, rồi quay lại khai mã."
      />
    );
  }

  return (
    <>
      {inScope.map((chain) => (
        <Form.Item
          key={chain.id}
          label={inScope.length === 1 ? 'Mã khuyến mãi KAS' : `Mã khuyến mãi KAS · ${chain.name}`}
          tooltip="Thu ngân gõ mã này bên máy tính tiền khi áp voucher. Để trống thì quầy không thấy mã nào."
        >
          <Input
            allowClear
            maxLength={KAS_CODE_MAX}
            placeholder="Để trống nếu chuỗi này chưa có mã"
            value={current[chain.id] ?? ''}
            onChange={(e) => onChange?.({ ...current, [chain.id]: e.target.value })}
          />
        </Form.Item>
      ))}
    </>
  );
}
